import { IMakeRequest } from '../../utils/make_request';
import { isResponseContainsKey } from '../../utils/response';
import { filterServerResponse } from '../helpers';
import { IServerError } from '../types';
import { TURIScheme } from '@cian/http-api/shared/uri';

export interface ISuccessResponse {
  status: 'ok';
}

export function sendFeedback(
  makeRequest: IMakeRequest,
  host: string,
  email: string,
  message: string,
  url: string,
): Promise<ISuccessResponse | IServerError> {
  return makeRequest({
    body: [
      `email=${encodeURIComponent(email)}`,
      `source=errorbti`,
      `text=${encodeURIComponent(message)}`,
      `url=${encodeURIComponent(url)}`,
    ].join('&'),
    headers: [
      ['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8'],
    ],
    method: 'POST',
    uri: {
      host,
      path: '/ajax/feedback/',
      scheme: document.location.protocol.slice(0, -1) as TURIScheme,
    },
  })
  .then(filterServerResponse)
  .then(response => JSON.parse(response.responseBody))
  .then(response => {
    if (!isResponseContainsKey<ISuccessResponse, IServerError>(response, 'errors')) {
      return response;
    }

    throw response;
  });
}
